module.exports = __webpack_public_path__ + "img/full4-min.1c7201be.png";